import React, { useEffect, useState } from 'react';
import { useFetch } from '../../../api/FetchApiData';
import { useParams } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import { BrowserView, isMobile, MobileView } from 'react-device-detect';
import PartnersMap from '../../../map/partners/PartnersMap';
import Popup from 'reactjs-popup';
import { useTranslation } from 'react-i18next';
if (!isMobile)
    import('./result.css').then(() => {});
else
    import('./result_mob.css').then(() => {});

function PaymentResult() {

    const fetchData = useFetch();
    const {status,id} = useParams();
    const [order,setOrder] = useState({id:'',ticket:'',total_price:''});
    const [partner, setPartner] = useState(null);
    const {t} = useTranslation();
    
    useEffect(()=>{
        let url = 'payment/cash/'+id+'/';
        console.log(status);
        if(status==='1')
        {url = 'payment/confirme/'+id+'/';}
        if(!!id)
        {
            fetchData.GetData(url).then((result)=>
            {
                if(result.result)
                {
                    if(status==='0')
                    {
                        setOrder({id:id,order_number:result.order_number,ticket:result.ticket,total_price:result.order.total_price,status});
                        setPartner({...result.partner});
                    }
                    else if(status==='1')
                    {
                        setOrder({id:id,order_number:result.order_number});
                        setPartner({...result.partner});
                    }
                }
            });
        }
    },[])

    const PopMobFindPartner = ()=>{
        return(<Popup trigger={<input type='button' style={{border:'none'}} className="button" value='Trouver un parténaire' />}>
            {close=>(
                <PartnersMap close = {close} />
            )}
        </Popup>)
    }

  return (
    <div className='cash-result'>
        <h1>{t('panier.command-valider')}</h1>
            <div className="details">
                {status==='0' && <>
                    <p style={{margin:'auto',marginBottom:'20px',color:'gray'}}>
                        {t('panier.payment-cash')}
                    </p>
                    <div className="p-4 bg-white shadow-lg rounded">
                        <QRCodeSVG value={order.ticket} size={200} />
                    </div></>
                }
                {status==='1' && <>
                    <p>
                        {t('panier.payment-confirmed')}
                    </p>
                </>}
            </div>
            {status==='0' &&
                <BrowserView>
                    <PartnersMap partner_={partner} />
                </BrowserView>
            }
            {status==='0' &&
            <MobileView>
                <PopMobFindPartner />
            </MobileView>
            }
    </div>
  )
}

export default PaymentResult;
    